import { actionCreator } from 'utils';
import * as AccountancyTypes from '../types/accountancyTypes';

const initState = {
    statisticsListing: {
        loading: false,
        error: false,
        data: null,
        offset: 0,
        limit: 50,
    },
    statisticsGroups: {
        loading: false,
        error: false,
        data: null,
        offset: 0,
        limit: 50,
    },
    exportsListing: {
        loading: false,
        error: false,
        data: null,
        offset: 0,
        limit: 50,
    },
    accountancyGroups: {
        loading: false,
        error: false,
        data: null,
        offset: 0,
        limit: 50,
    },
    invoice: {
        loading: false,
        error: false,
        data: null,
        offset: 0,
        limit: 50,
        sort: '',
        filters: {
            invoiceNumber: '',
            customerNumber: '',
            orderNumber: '',
            company: '',
            clientName: '',
            daysOpen: '',
            timeLimit: '',
            createdAt: [],
            paymentStatus: undefined,
            ogm: '',
            vatNumber: '',
            billingAccount: '',
            isProforma: false,
        },
        orders: {
            loading: false,
            data: null,
        },
        exportInvoices: {
            loading: false,
            error: false,
        },
    },
};

export default function reducer(state = initState, action) {
    switch (action.type) {
    case AccountancyTypes.EXPORT_ACCOUNTANCY_GROUPS:
        return Object.assign({}, state, {
            exportsListing: {
                ...state.exportsListing,
                loading: true,
                error: false,
            },
        });

    case actionCreator(AccountancyTypes.EXPORT_ACCOUNTANCY_GROUPS, 'res'):
        return Object.assign({}, state, {
            exportsListing: {
                ...state.exportsListing,
                loading: false,
                data: action.data,
            },
        });


    case actionCreator(AccountancyTypes.EXPORT_ACCOUNTANCY_GROUPS, 'err'):
        return Object.assign({}, state, {
            exportsListing: {
                ...state.exportsListing,
                loading: false,
                error: true,
            },
        });

    case AccountancyTypes.SET_ACCOUNTANCY_EXPORTS_PAGINATION:
        return Object.assign({}, state, {
            exportsListing: {
                ...state.exportsListing,
                [action.key]: action.pagination,
            },
        });

    case AccountancyTypes.LOAD_ACCOUNTANCY_EXPORTS:
        return Object.assign({}, state, {
            exportsListing: {
                ...state.exportsListing,
                loading: true,
                error: false,
            },
        });


    case AccountancyTypes.LOAD_ACCOUNTANCY_GROUPS:
        return Object.assign({}, state, {
            accountancyGroups: {
                ...state.accountancyGroups,
                loading: true,
                error: false,
            },
        });

    case actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_GROUPS, 'res'):
        return Object.assign({}, state, {
            accountancyGroups: {
                ...state.accountancyGroups,
                loading: false,
                data: action.data,
            },
        });


    case actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_GROUPS, 'err'):
        return Object.assign({}, state, {
            accountancyGroups: {
                ...state.accountancyGroups,
                loading: false,
                error: true,
            },
        });


        // S T A T I S T I C S

    case AccountancyTypes.EXPORT_STATISTICS_GROUPS:
        return Object.assign({}, state, {
            statisticsListing: {
                ...state.statisticsListing,
                loading: true,
                error: false,
            },
        });

    case actionCreator(AccountancyTypes.EXPORT_STATISTICS_GROUPS, 'res'):
        return Object.assign({}, state, {
            statisticsListing: {
                ...state.statisticsListing,
                loading: false,
                data: action.data,
            },
        });


    case actionCreator(AccountancyTypes.EXPORT_STATISTICS_GROUPS, 'err'):
        return Object.assign({}, state, {
            statisticsListing: {
                ...state.statisticsListing,
                loading: false,
                error: true,
            },
        });

    case AccountancyTypes.SET_STATISTICS_EXPORTS_PAGINATION:
        return Object.assign({}, state, {
            statisticsListing: {
                ...state.statisticsListing,
                [action.key]: action.pagination,
            },
        });

    case AccountancyTypes.LOAD_STATISTICS_EXPORTS:
        return Object.assign({}, state, {
            statisticsListing: {
                ...state.statisticsListing,
                loading: true,
                error: false,
            },
        });
    case AccountancyTypes.LOAD_STATISTICS_GROUPS:
        return Object.assign({}, state, {
            statisticsGroups: {
                ...state.statisticsGroups,
                loading: true,
                error: false,
            },
        });

    case actionCreator(AccountancyTypes.LOAD_STATISTICS_GROUPS, 'res'):
        return Object.assign({}, state, {
            statisticsGroups: {
                ...state.statisticsGroups,
                loading: false,
                data: action.data,
            },
        });
    case actionCreator(AccountancyTypes.LOAD_STATISTICS_GROUPS, 'err'):
        return Object.assign({}, state, {
            statisticsGroups: {
                ...state.statisticsGroups,
                loading: false,
                error: true,
            },
        });
        // S T A T I S T I C S

        // I N V O I C E

    case AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                loading: true,
                error: false,
            },
        });

    case actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE, 'res'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                loading: false,
                data: action.data,
            },
        });


    case actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE, 'err'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                loading: false,
                error: true,
                orders: {
                    ...state.invoice.orders,
                    loading: false,
                },
            },
        });

    case AccountancyTypes.SET_ACCOUNTANCY_INVOICE_PAGINATION:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                [action.key]: action.pagination,
            },
        });

    case AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE_ORDERS:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                orders: {
                    ...state.invoice.orders,
                    loading: true,
                },
            },
        });

    case actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE_ORDERS, 'res'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                orders: {
                    data: action.data,
                    loading: false,
                },
            },
        });

    case actionCreator(AccountancyTypes.LOAD_ACCOUNTANCY_INVOICE_ORDERS, 'err'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                orders: {
                    ...state.invoice.orders,
                    loading: false,
                },
            },
        });

    case AccountancyTypes.SET_ACCOUNTANCY_INVOICE_SORT:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                sort: action.sort,
            },
        });

    case AccountancyTypes.SET_ACCOUNTANCY_INVOICE_FILTERS:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                filters: {
                    ...state.invoice.filters,
                    [action.key]: action.value,
                },
            },
        });

    case AccountancyTypes.RESET_ACCOUNTANCY_INVOICE_FILTERS:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                filters: initState.invoice.filters,
            },
        });

    case AccountancyTypes.EXPORT_INVOICES:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                exportInvoices: {
                    ...state.invoice.exportInvoices,
                    loading: true,
                },
            },
        });

    case actionCreator(AccountancyTypes.EXPORT_INVOICES, 'res'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                exportInvoices: {
                    ...state.invoice.exportInvoices,
                    error: false,
                    loading: false,
                },
            },
        });

    case actionCreator(AccountancyTypes.EXPORT_INVOICES, 'err'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                exportInvoices: {
                    ...state.invoice.exportInvoices,
                    error: true,
                    loading: false,
                },
            },
        });

        // I N V O I C E
    default:
        return state;
    }
}
